import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=8685c28a&"
import script from "./MobileButton.ts?vue&type=script&lang=js&"
export * from "./MobileButton.ts?vue&type=script&lang=js&"
import style0 from "./MobileButton.vue?vue&type=style&index=0&id=8685c28a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports